import {Injectable} from '@angular/core';
import {GeneralLabelUrlModel} from '@models/@base/general-label-url.model';

@Injectable({
    providedIn: 'root'
})
export class LocalStorageService {

    public FormSearchTerms = 'ApolloFormsSearchTerms';

    constructor() {
    }

    /**
     * Save search term for Form
     * @param form
     * @param term
     */
    saveSearchTerm(form: string, term: string): void {
        localStorage.setItem(`${this.FormSearchTerms}_${form}`, term);
    }

    /**
     * Get search term for Form
     * @param form
     */
    loadSearchTerm(form: string): string {
        const searchTerm = localStorage.getItem(`${this.FormSearchTerms}_${form}`);
        return searchTerm == null || (searchTerm && searchTerm.toLocaleLowerCase() === 'null') ? '' : searchTerm;
    }

    /**
     * Saves array as string joined by pipe
     * @param key
     * @param val
     */
    saveArrayValue<T>(key: string, val: T[]): void {
        localStorage.setItem(key, val.join('|'));
    }

    /**
     * Load array
     * @param key
     */
    loadArrayValue<T>(key: string): T[] {
        const val = localStorage.getItem(key);
        if (val) {
            return val.split('|').map(s => (s as unknown) as T);
        }
        return [];
    }

    saveGuardRedirectUrl(data: GeneralLabelUrlModel[]): void {
        localStorage.setItem(`guardResultRedirectUrls`, data ? JSON.stringify(data) : '[]');
    }

    loadGuardRedirectUrl(): GeneralLabelUrlModel[] {
        const urls = localStorage.getItem(`guardResultRedirectUrls`);
        return (urls == null || (urls && urls.toLocaleLowerCase() === 'null') ? [] : (JSON.parse(urls) as GeneralLabelUrlModel[]));
    }
}
